/* eslint-disable */
import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { IoniconsOutline } from '@pt/pt-models';
import { ColumnWithLocalization } from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';
import { QuerySpecificationUtils } from '../../utils';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ColumnType } from 'it/primatoo/openapi/api/org/schemas/common/ColumnType';
import { NgbCalendar, NgbDate, NgbDatepickerNavigateEvent, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AbstractComposableRouterComponent, TimeUtils } from '@pt/pt-core';
import { TableFilterUtils } from './table-filter.utils';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LogService } from '@pt/api-client';
import { TableFilterItem } from './table-filter-item';

@Component({
  selector: 'pt-table-filter',
  templateUrl: 'table-filter.component.html',
  styleUrls: ['table-filter.component.scss'],
})
export class TableFilterComponent
  extends AbstractComposableRouterComponent
  implements OnChanges, AfterViewInit
{
  protected getTabKey(): string {
    return 'table-filter';
  }

  protected changedTab(tab: string): void {
    if (this.logService.isLoggable('DEBUG')) {
      console.log('%c[DEBUG]TableFilterComponent: ', tab, 'color: #FF8E31;font-weight:bold;');
    }
  }

  @Input() showReindex: boolean;
  @Input() reindexRunning: boolean;
  @Input() columns: ColumnWithLocalization[];

  @Output() settings = new EventEmitter<void>();
  @Output() resetRequest = new EventEmitter<string>();
  @Output() searchRequest = new EventEmitter<string>();

  @ViewChild('select', { static: false }) select: NgSelectComponent;

  public currentItems: TableFilterItem[] = [];
  public selectedValue: TableFilterItem[] = [];

  public renderDataPicker = true;
  public firstLoadingCompleted = false;
  public IconClose = IoniconsOutline.close;
  public IconSearch = IoniconsOutline.search;
  public IconSettings = IoniconsOutline.settings;
  public model: NgbDateStruct = this.calendar.getToday();
  public date: { year: number; month: number };

  public addTag = false;
  public disabledSearch = false;
  public filterId = 'table-filter-id';

  public query: string | undefined;
  public enabledSearch = false;

  public QS = QuerySpecificationUtils;

  public cleanFilter() {
    this.selectedValue = [];
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent) {
    const lastCol = this.selectedValue?.find(
      (_value, index, list) => index === list.length - 1
    );
    if (lastCol && lastCol.columnType === ColumnType.NUMBER) {
      if (
        [46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+V
        (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)
      ) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if (
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault();
      }
    }
  }

  constructor(public calendar: NgbCalendar, private logService: LogService) {
    super();
    // TableFilterUtils.debugTest();
    this.composableRouteService
      .onChangeRoute(this.getTabKey())
      .pipe(takeUntilDestroyed())
      .subscribe((query: string) => {
        this.query = TableFilterUtils.toQuery(this.selectedValue);
        if (this.query !== query) {
          this.selectedValue = TableFilterUtils.fromQuery(query);
          this.changeModels(this.selectedValue || [], true);
          // this.search()
        } else {
          // this.composableRouteService.removeValue(this.getTabKey())
        }
      });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      document.getElementById(this.filterId)?.focus();
    }, 500);
  }

  addDate(date: NgbDateStruct) {
    const value = TimeUtils.toStringDate(date);
    const newItem: TableFilterItem[] = [
      ...this.selectedValue,
      {
        value: value,
        type: 'value',
        column: undefined,
        columnType: undefined,
      },
    ];
    this.updateStatus(newItem, true);
  }

  onDateNavigate(e: NgbDatepickerNavigateEvent) {
    this.date = e.next;
  }

  onDateSelect(e: NgbDate) {
    this.addDate(e);
  }

  onBooleanSelect(e: boolean) {
    this.addBoolean(e);
  }

  addBoolean(bool: boolean) {
    const newItem: TableFilterItem[] = [
      ...this.selectedValue,
      {
        value: bool ? 'true' : 'false',
        type: 'value',
        column: undefined,
        columnType: undefined,
      },
    ];
    this.updateStatus(newItem, true);
  }

  reset() {
    this.changeModels([], true);
    this.model = this.calendar.getToday();
    this.resetRequest.emit();
    this.composableRouteService.selectValue(this.getTabKey(), '');
  }

  customSearchFn(term: string, item: TableFilterItem) {
    term = term.toLowerCase();
    return (
      item.value.toLowerCase().indexOf(term) > -1 ||
      item.value.toLowerCase() === term
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.columns) {
      this.changeModels(this.selectedValue || []);
    }
  }

  enabledDate(): boolean {
    const element = this.selectedValue.length;
    return (
      element >= 2 &&
      this.selectedValue[element - 1]?.type === 'operator' &&
      this.selectedValue[element - 2]?.columnType === 'DATE'
    );
  }

  enabledBoolean(): boolean {
    const element = this.selectedValue.length;
    return (
      element >= 2 &&
      this.selectedValue[element - 1]?.type === 'operator' &&
      this.selectedValue[element - 2]?.columnType === 'BOOLEAN'
    );
  }

  search() {
    this.query = TableFilterUtils.toQuery(this.selectedValue);
    this.composableRouteService.selectValue(this.getTabKey(), this.query);
    this.searchRequest.emit(this.query);
  }

  onRemoveItem(__item: any) {
    // this.model = undefined;
  }

  clearItem(_item: any, index: number) {
    this.model = this.calendar.getToday();
    const result: TableFilterItem[] = [];
    this.selectedValue.forEach((value, i) => {
      if (i < index - 2 || i > index) {
        result.push(value);
      }
    });
    this.changeModels(result, true);
  }

  keydownEnter() {
    setTimeout(() => {
      if (!this.disabledSearch) {
        this.search();
      }
    });
  }

  keydownBackspace() {
    this.renderDataPicker = false;
    setTimeout(() => {
      if (!this.disabledSearch) {
        this.search();
      }
      this.renderDataPicker = true;
    });
  }

  log(value: number) {
    console.log(value + '. log');
  }

  changeModels($event: Array<TableFilterItem | string>, search = false) {
    this.disabledSearch = $event.length % 3 !== 0; // $event.length === 0 ||
    const newSelectedValue: TableFilterItem[] = [];
    $event.forEach((e) => {
      if (typeof e === 'string') {
        newSelectedValue.push(this.tableFilterItemFromValue(e as string));
      } else {
        newSelectedValue.push(e as TableFilterItem);
      }
    });
    this.updateStatus(newSelectedValue, search);
  }

  private updateStatus(status: TableFilterItem[], search: boolean) {
    setTimeout(() => {
      this.selectedValue = status;
      const col: ColumnWithLocalization[] =
        this.columns?.filter((c) => {
          return (
            c.uiAvailable === true && c.operations && c.operations.length > 0
          );
        }) || [];
      this.enabledSearch = col.length > 0;
      switch (this.selectedValue.length % 3) {
        case 0:
          this.addTag = false;
          this.currentItems = col.map((c) =>
            this.tableFilterItemFromColumnWithLocalization(c)
          );
          break;
        case 1: {
          this.addTag = false;
          if (this.select) {
            this.select.open();
          }
          const currentCol = this.selectedValue[this.selectedValue.length - 1];
          this.currentItems = this.tableFilterItemFromOperator(
            col.find((c) => c.label === currentCol.value)
          );
          break;
        }
        case 2:
          this.addTag = true;
          if (this.select) {
            this.select.open();
          }
          this.currentItems = [];
          break;
      }
      this.query = TableFilterUtils.toQuery(this.selectedValue);
      this.firstLoadingCompleted = true;
      if (search) {
        this.search();
      }
    });
  }

  private tableFilterItemFromColumnWithLocalization(
    col: ColumnWithLocalization
  ): TableFilterItem {
    return {
      type: 'column',
      value: col.label,
      column: col.column,
      columnType: col.type,
    };
  }

  private tableFilterItemFromOperator(
    col?: ColumnWithLocalization
  ): TableFilterItem[] {
    const response: TableFilterItem[] = [];
    if (col && col.operations.length > 0) {
      col.operations.forEach((o) => {
        const item: TableFilterItem = {
          value: o,
          type: 'operator',
          column: col.column,
          columnType: col.type,
        };
        response.push(item);
      });
    }
    return response;
  }

  private tableFilterItemFromValue(value: string): TableFilterItem {
    return {
      value: value,
      type: 'value',
      column: undefined,
      columnType: undefined,
    };
  }
}

